import { ContractStatusEnum } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import { Button, ContextMenu, IconKebab } from 'uikit';

import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { RowData } from '../PriceListUER/types';

interface IPriceListUerRowMenu {
    row: RowData;
    contractStatus: ContractStatusEnum | undefined;
    priceListRules: IUseAccess['priceList'];
}

export const PriceListUerRowMenu = ({ row, contractStatus, priceListRules }: IPriceListUerRowMenu) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const navigate = useNavigate();

    const handleOnClick = useCallback((e = null) => {
        e?.stopPropagation?.();

        setIsOpen((prevState) => !prevState);
    }, []);

    const handleItemClick = (): any => {
        navigate(`editUer/${row.id}`, { replace: true });

        handleOnClick();
    };

    const isContractStatusWork = contractStatus === ContractStatusEnum.InImplementation;

    return (
        <>
            <Button
                iconLeft={IconKebab}
                onlyIcon
                view="clear"
                size="xs"
                ref={ref}
                onClick={handleOnClick}
                disabled={!isContractStatusWork}
            />
            <ContextMenu
                isOpen={isOpen}
                items={!priceListRules?.canEdit ? ['Посмотреть'] : ['Редактировать']}
                getItemLabel={(item) => item}
                anchorRef={ref}
                direction="downStartLeft"
                getItemOnClick={handleItemClick}
                onClickOutside={handleOnClick}
            />
        </>
    );
};

PriceListUerRowMenu.displayName = 'PriceListUerRowMenu';
